var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 3.99999H19.45V20.8H5.05V3.99999H7.45V2.79999C7.45 2.16347 7.70286 1.55302 8.15294 1.10294C8.60303 0.65285 9.21348 0.399994 9.85 0.399994H14.65C15.2865 0.399994 15.897 0.65285 16.3471 1.10294C16.7971 1.55302 17.05 2.16347 17.05 2.79999V3.99999ZM20.65 3.99999H21.85C22.4865 3.99999 23.097 4.25285 23.5471 4.70294C23.9971 5.15302 24.25 5.76347 24.25 6.39999V18.4C24.25 19.0365 23.9971 19.647 23.5471 20.097C23.097 20.5471 22.4865 20.8 21.85 20.8H20.65V3.99999ZM3.85 3.99999V20.8H2.65C2.01348 20.8 1.40303 20.5471 0.952944 20.097C0.502856 19.647 0.25 19.0365 0.25 18.4V6.39999C0.25 5.07999 1.33 3.99999 2.65 3.99999H3.85ZM9.85 2.79999V3.99999H14.65V2.79999H9.85Z",
    fill: "#0085CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseBlue);
export default __webpack_public_path__ + "static/media/case_blue.5a56a43f.svg";
export { ForwardRef as ReactComponent };